export { default } from "./SearcherViewContainer";
export { default as i18n } from "./i18n";
export { default as reducer } from "./reducer";

import { SearchViewState as TSearchViewState } from "./types";
export type SearchViewState = TSearchViewState;
